import { Box, Stack } from '@mui/material';
type Props = {
  fullWidth?: boolean;
};
const DomainCheckWarning = ({
  fullWidth = false
}: Props) => <Stack sx={{
  flexDirection: 'row',
  position: 'fixed',
  bottom: 0,
  width: '100%',
  zIndex: 2
}} data-sentry-element="Stack" data-sentry-component="DomainCheckWarning" data-sentry-source-file="DomainCheckWarning.tsx">
    <Box sx={{
    textAlign: 'center',
    py: 'var(--spacing_m)',
    flex: 1,
    bgcolor: 'background.bg2'
  }} data-sentry-element="Box" data-sentry-source-file="DomainCheckWarning.tsx">
      مطمئن شوید که در دامنه zeema.fund هستید.
    </Box>

    {!fullWidth ? <Box sx={{
    display: {
      md: 'initial',
      xs: 'none'
    },
    flex: 1.3
  }} /> : null}
  </Stack>;
export default DomainCheckWarning;